module.exports = __webpack_public_path__ + "assets/icStable.4ec61b61.svg";